import React, { useCallback } from "react";
import { connect } from "react-redux";

import { toggleWeeklyReport } from "@app/scene/reports/store/actions";
import WeeklyReportSetting from "@app/types/report/WeeklyReportCardSettings";

import OptedIn from "./OptedIn";
import OptedOut from "./OptedOut";

interface Props {
  formData: WeeklyReportSetting["value"];
  toggleWeeklyReport: (payload: { enabled: boolean }) => void;
}

const OptInOut: React.FC<Props> = ({ formData, toggleWeeklyReport }) => {
  const handleToggle = useCallback(
    (enabled: boolean) => {
      toggleWeeklyReport({ enabled });
    },
    [toggleWeeklyReport]
  );

  return formData.enabled ? (
    <OptedIn onToggle={handleToggle} />
  ) : (
    <OptedOut onToggle={handleToggle} />
  );
};

const mapDispatchToProps = {
  toggleWeeklyReport: toggleWeeklyReport.request,
};

export default connect(null, mapDispatchToProps)(OptInOut);
